import { render, staticRenderFns } from "./TrainingInternalMenuForm.vue?vue&type=template&id=bbd8fbc4&"
import script from "./TrainingInternalMenuForm.vue?vue&type=script&lang=js&"
export * from "./TrainingInternalMenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports